import Utils from 'services/utils';
import Config from 'services/config/local';

// noinspection JSUnresolvedVariable,Eslint
if (!ENVIRONMENT || ['development', 'test'].indexOf(ENVIRONMENT)) {
    require('./role.json'); // eslint-disable-line global-require
    require('./roles.json'); // eslint-disable-line global-require
}

/**
 * Response parser
 * @param {{data:Object|Array}} response - Response object
 * @returns {Array|Object}
 */
function responseDataExtractor(response) {
    return response.data;
}

/**
 * RolesApi class.
 */
export default class RolesApi {
    /**
     * @param {$http} $http - Angular $http service
     * @constructor
     * @ngInject
     */
    constructor($http) {
        this.$http = $http;
        this.config = Config.api.roles;
    }

    /**
     * Get Roles
     * @returns {promise}
     */
    getList() {
        return this.$http.get(this.config.listUrl).then(responseDataExtractor);
    }

    /**
     * Search Role by given query
     * @param {string} query - Search pattern
     * @param {Object} metadata - Request settings, like: limit, ofset etc.
     * @returns {promise}
     */
    search(query, metadata = {}) {
        return this.$http.get(
            this.config.searchUrl,
            {
                params: {
                    query: `${query}*`,
                    ...metadata
                }
            })
            .then(responseDataExtractor);
    }

    /**
     * Get Role by given id
     * @param {number} roleId - Role id
     * @returns {promise}
     */
    getRole(roleId) {
        const url = Utils.formatString({ roleId }, this.config.getUrl);

        return this.$http.get(url).then(responseDataExtractor);
    }

    /**
     * Delete Role by given id
     * @param {number} roleId - Role id
     * @returns {promise}
     */
    deleteRole(roleId) {
        const url = Utils.formatString({ roleId }, this.config.deleteUrl);

        return this.$http.delete(url).then(responseDataExtractor);
    }

    /**
     * Update Role
     * @param {number} roleId - Role id
     * @param {Object} role - Role object
     * @returns {promise}
     */
    updateRole(roleId, role) {
        const url = Utils.formatString({ roleId }, this.config.updateUrl);

        return this.$http.put(url, role).then(responseDataExtractor);
    }

    /**
     * Create Role
     * @param {Object} role - Role object
     * @returns {promise}
     */
    createRole(role) {
        return this.$http.post(this.config.createUrl, { ...role }).then(responseDataExtractor);
    }

    /**
     * Add users to role
     * @param {number} roleId - Role id
     * @param {Array<number>} users - User ids
     * @returns {promise}
     */
    addUsersToRole(roleId, users) {
        const url = Utils.formatString({ roleId }, this.config.addUsersUrl);

        return this.$http.post(url, { 'user_ids': users }).then(responseDataExtractor);
    }

    /**
     * Delete users from role
     * @param {number} roleId - Role id
     * @param {Array<number>} users - User ids
     * @returns {promise}
     */
    deleteUsersFromRole(roleId, users) {
        const url = Utils.formatString({ roleId }, this.config.deleteUsersUrl);

        return this.$http.post(url, { 'user_ids': users }).then(responseDataExtractor);
    }

}



// WEBPACK FOOTER //
// ./app/services/api/roles/roles.service.js